<template>
  <Menu as="div" v-slot="{ open }" :class="menuClasses">
    <div ref="trigger">
      <slot name="trigger" />
    </div>
    <Portal>
      <div ref="container" class="z-20">
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <div v-show="open">
            <MenuItems
              static
              :class="classes"
              class="absolute origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:divide-gray-500 dark:bg-gray-600"
            >
              <slot />
            </MenuItems>
          </div>
        </transition>
      </div>
    </Portal>
  </Menu>
</template>

<script setup>
import { usePopper } from '@/Common/util/hooks/usePopper'
import { Menu, MenuItems, Portal } from '@headlessui/vue'
import { computed } from 'vue'

const props = defineProps({
  placement: {
    type: String,
    default: 'right',
  },
  width: {
    type: String,
    default: 'md',
  },
})

const widthClass = computed(() => {
  return {
    sm: 'w-48',
    md: 'w-56',
  }[props.width]
})

const placementClass = computed(() => {
  return {
    right: 'right-0',
    left: '',
  }[props.placement]
})

const classes = computed(() =>
  [placementClass.value, widthClass.value].join(' ')
)

let [trigger, container] = usePopper({
  placement: props.placement === 'right' ? 'bottom-end' : 'bottom-start',
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 8],
      },
    },
    {
      name: 'computeStyles',
      options: {
        adaptive: false, // true by default
      },
    },
    {
      name: 'preventOverflow',
      options: {
        tether: false,
      },
    },
  ],
})

const menuClasses = computed(() => {
  const text = trigger.value?.textContent

  return text?.includes('Open item options')
    ? 'relative flex justify-end items-center'
    : 'relative inline-block text-left'
})
</script>
